import { XMarkIcon } from '@heroicons/react/24/solid';
import { PhotoIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { useCallback, useState } from 'react';
import { IMAGE_POP_OVER_HEIGHT, IMAGE_POP_OVER_WIDTH } from '../commons/constants/constants';
interface ImagePopOverProps {
  id?: string;
  src: string;
  width: number;
  height: number;
  alt: string;
  className?: string;
  asImageIcon?: boolean;
}
const ImagePopOver: React.FC<ImagePopOverProps> = ({
  id,
  src,
  width,
  height,
  alt,
  className = '',
  asImageIcon = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleImageLoadComplete = useCallback((): void => {
    setIsLoading(false);
  }, []);
  const handleTogglePopOver = (): void => {
    setIsOpen(prev => !prev);
  };
  return <>
      <button className='block' onClick={handleTogglePopOver}>
        {asImageIcon ? <PhotoIcon className='w-6 h-6' /> : <Image id={id} src={src} alt={alt} width={width} height={height} className={`${className} cursor-pointer`} />}
      </button>

      {isOpen && <div className='fixed inset-0 flex items-center justify-center z-50'>
          <div className='fixed inset-0 bg-black bg-opacity-50' onClick={handleTogglePopOver} />
          <div className='bg-white p-4 rounded-lg shadow-lg relative'>
            <button onClick={handleTogglePopOver} className='absolute top-2 right-2 text-gray-600 hover:text-gray-900'>
              <XMarkIcon className='h-6 w-6' />
            </button>

            {isLoading && <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-50'>
                <div className='w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin'></div>
              </div>}

            <Image id={id} src={src} alt={alt} width={IMAGE_POP_OVER_WIDTH} height={IMAGE_POP_OVER_HEIGHT} className='rounded-lg pt-5' onLoadingComplete={handleImageLoadComplete} />
          </div>
        </div>}
    </>;
};
export default ImagePopOver;